<template>
  <BaseButton primary @click="createAccProductTemplate"> New Template </BaseButton>
</template>

<script>
export default {
  methods: {
    createAccProductTemplate() {
      this.$modal.show({
        component: () => import('Components/AccProductTemplates/AccProductTemplateCreateModal.vue'),
        on: {
          created: (id) => {
            this.$emit('created', id);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
